// Shared device selection for the responsive preview and the page-builder canvas,
// persisted so both surfaces open at the same reference viewport.
(function () {
  var STORAGE_KEY = "responsive-preview-device-type";
  var DEFAULT_TYPE = "desktop";

  window.Sparkle = window.Sparkle || {};
  window.Sparkle.DevicePreference = {
    get: function () {
      try {
        return window.localStorage.getItem(STORAGE_KEY) || DEFAULT_TYPE;
      } catch (error) {
        return DEFAULT_TYPE;
      }
    },

    set: function (deviceType) {
      // "Fill Window" is surface-relative (the canvas and the preview fill different
      // areas), so it is never persisted as a shared reference width.
      if (deviceType === "unconstrained") {
        return;
      }

      try {
        window.localStorage.setItem(STORAGE_KEY, deviceType);
      } catch (error) {
        // Storage unavailable; the selection just won't persist.
      }
    },
  };
})();
